import Vue from "vue";
import Notifications from "vue-notification";
import Axios from "axios";
import "./assets/style.scss"; // eslint-disable-line import/no-unassigned-import
import App from "./App";
import Topbar from "./components/Topbar";
import IconBase from "./components/IconBase";
import Price from "./components/Price";
import router from "./router";
import store from "./store";
import "./filters"; // eslint-disable-line import/no-unassigned-import
import startSentry from "./monitoring/sentry";

Vue.config.productionTip = false;

const isProduction = process.env.NODE_ENV === "production"; // eslint-disable-line no-undef

// eslint-disable-line import/prefer-default-export
if (isProduction) {
  startSentry({
    sentryDSN: process.env.VUE_APP_SENTRY_DSN,
    sentryEnvironment: process.env.VUE_APP_SENTRY_ENVIRONMENT
  });
}

Axios.defaults.baseURL = process.env.VUE_APP_API_URL;
Vue.prototype.$http = Axios;

const token = localStorage.getItem("token");

if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = `Token token=${token}`;
}

Vue.use(Notifications);

Vue.component("Topbar", Topbar);
Vue.component("IconBase", IconBase);
Vue.component("Price", Price);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
